export default "__VITE_ASSET__D4Jxm6a2__"